module.exports = "/build/web/images/cta.2b44af9741638c671249e0e4e7a7e0ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/cta.jpg
// module id = 120
// module chunks = 11